<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col cols="12" md="6" lg="5">
          <span>PAGOS: SOLICITUDES DE PAGOS</span>
        </v-col>

        <v-col cols="12" md="6" lg="5">
          <v-pagination
            class="custom-pagination"
            v-model="pagina"
            :length="metadatos?.totalPaginas || 0"
            :total-visible="10"
            @input="listar"></v-pagination>
        </v-col>

        <v-col cols="12" md="6" lg="2">
          <v-select
            :items="[10, 25, 50, 75, 100]"
            label="Items por página"
            v-model="itemsPorPagina"
            outlined
            dense
            hide-details
            :disabled="items.length == 0"
            @change="cambiarPagina" />
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-row dense>
      <v-col v-if="this.$store.state.CARGO.id == 1" cols="12" md="3" xl="2">
        <div class="d-flex">
          <v-switch
            style="margin-top: -4px"
            v-model="mostrarTodasSedes"
            hide-details
            label="Ver todas las sedes"></v-switch>
        </div>
      </v-col>

      <v-col cols="12" :md="this.$store.state.CARGO.id == 1 ? 4 : 7" :xl="this.$store.state.CARGO.id == 1 ? 6 : 8">
        <v-btn class="mx-1" title="Recargar" small @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <v-btn
          v-if="permisosPresupuestos2 || permisosGestionEmpresarial || permisosContabilidadNacional"
          small
          class="mx-1"
          :disabled="item == null"
          title="Realizar Pagos"
          @click="$refs.modalPagosUniversidadesRef.abrir(accionesCrud.EDITAR, item)">
          <v-icon>mdi-cash</v-icon>

          Realizar Pagos
        </v-btn>

        <v-btn
          class="mx-1"
          title="Ver Solicitud"
          small
          :loading="cargandoSolicitudPago"
          :disabled="item == null || cargandoSolicitudPago"
          @click="obtenerSolicitudPago">
          <v-icon>mdi-eye</v-icon>

          Ver Solicitud
        </v-btn>

        <v-menu
          offset-y
          v-if="
            permisosPresupuestos2 ||
            permisosGestionEmpresarial ||
            permisosContabilidadNacional ||
            permisosAcademicosNacional
          ">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              title="Descargar Excel Solicitudes de Pagos Consolidado"
              small
              :disabled="descargandoExcelSolicitudesPagosConsolidado"
              :loading="descargandoExcelSolicitudesPagosConsolidado">
              Excel Solicitudes de Pagos Consolidado
            </v-btn>
          </template>

          <v-list>
            <v-list-item link>
              <v-list-item-title @click="obtenerExcelSolicitudesPagosConsolidado('enero')">
                <v-icon>mdi-file-excel</v-icon>

                Enero
              </v-list-item-title>
            </v-list-item>

            <v-list-item link>
              <v-list-item-title @click="obtenerExcelSolicitudesPagosConsolidado('febrero')">
                <v-icon>mdi-file-excel</v-icon>

                Febrero
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu
          offset-y
          v-if="
            permisosPresupuestos2 ||
            permisosGestionEmpresarial ||
            permisosContabilidadNacional ||
            permisosAcademicosNacional
          ">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              title="Descargar PDF Solicitudes de Pagos Consolidado"
              small
              :disabled="descargandoPdfSolicitudesPagosConsolidado"
              :loading="descargandoPdfSolicitudesPagosConsolidado">
              PDF Solicitudes de Pagos Consolidado
            </v-btn>
          </template>

          <v-list>
            <v-list-item link>
              <v-list-item-title @click="obtenerPdfSolicitudesPagosConsolidado('enero')">
                <v-icon>mdi-file-pdf</v-icon>

                Enero
              </v-list-item-title>
            </v-list-item>

            <v-list-item link>
              <v-list-item-title @click="obtenerPdfSolicitudesPagosConsolidado('febrero')">
                <v-icon>mdi-file-pdf</v-icon>

                Febrero
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>

      <v-col cols="12" md="2" xl="2">
        <div class="d-flex">
          <v-switch
            style="margin-top: -4px"
            v-model="mostradoDetalleSolicitudesPagos"
            hide-details
            label="Mostrar detalles"></v-switch>
        </div>
      </v-col>

      <v-col cols="12" md="3" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="buscar"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoSolicitudesPagosPaginados
          ref="listadoRef"
          :items="items"
          :cargando="cargando"
          @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalPagosUniversidades ref="modalPagosUniversidadesRef" :nombreRecurso="nombreItem" @actualizarListado="listar" />

    <ModalMostrarSolicitudPago ref="modalMostrarSolicitudPagosRef" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoSolicitudesPagosPaginados from '../components/ListadoSolicitudesPagosPaginados.vue';
import SolicitudPagoService from '../services/solicitud-pago.service';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ModalPagosUniversidades from '../components/ModalPagosUniversidades.vue';
import { mapGetters } from 'vuex';
import ModalMostrarSolicitudPago from '../components/ModalMostrarSolicitudPago.vue';
import programaUniversidadExcelService from '../services/programa-universidad-excel.service';
import programaUniversidadPdfService from '../services/programa-universidad-pdf.service';

export default {
  name: 'SolicitudesPagosLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoSolicitudesPagosPaginados,
    ModalPagosUniversidades,
    ModalMostrarSolicitudPago,
  },
  data() {
    return {
      nombreItem: 'Pago Universidad',
      solicitudPago: null,
      cargandoSolicitudPago: false,
      mostrarTodasSedes: false,
      descargandoExcelSolicitudesPagosConsolidado: false,
      descargandoPdfSolicitudesPagosConsolidado: false,
    };
  },
  mounted() {
    this.listar();
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      if (!this.mostrarTodasSedes) {
        this.listarRestableciendoPagina();
      }
    },
    mostrarTodasSedes() {
      this.listarRestableciendoPagina();
    },
  },
  computed: {
    ...mapGetters({
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
      permisosGestionEmpresarial: 'pago/permisosGestionEmpresarial',
      permisosContabilidadNacional: 'pago/permisosContabilidadNacional',
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
    }),
    mostradoDetalleSolicitudesPagos: {
      get() {
        return this.$store.state.listado.mostradoDetalleSolicitudesPagos;
      },
      set(value) {
        this.$store.dispatch('listado/setMostradoDetalleSolicitudesPagos', value);
      },
    },
  },
  methods: {
    listar() {
      const params = {
        pagina: this.pagina,
        itemsPorPagina: this.itemsPorPagina,
        busqueda: this.busqueda,
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
      };

      this.obtenerDatosPaginadosConNotificacion(
        SolicitudPagoService.findAllPaginado,
        'items',
        'metadatos',
        this.nombreItem,
        params,
      );

      this.item = null;
    },
    obtenerSolicitudPago() {
      if (!this.item) {
        return;
      }

      this.cargandoSolicitudPago = true;

      this.obtenerDatosV2Mixin(SolicitudPagoService.findOne, 'solicitudPago', this.item.id)
        .then(() => {
          this.$refs.modalMostrarSolicitudPagosRef.abrir(this.solicitudPago);
        })
        .finally(() => {
          this.cargandoSolicitudPago = false;
        });
    },
    async obtenerExcelSolicitudesPagosConsolidado(mes) {
      if (!mes) {
        return;
      }

      this.descargandoExcelSolicitudesPagosConsolidado = true;

      try {
        const params = {
          mes,
        };
        const response = await programaUniversidadExcelService.inscritosSolicitudesPagosConsolidadosRaw({ params });
        const data = response.data;
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `solicitudes_pagos_consolidado_${mes}.xlsx`);
        document.body.appendChild(link);
        link.click();

        this.$notify({
          group: 'notifications',
          title: 'Exportación exitosa',
          text: 'Solicitudes de pagos consolidadas exportadas correctamente',
          type: 'success',
        });
      } catch (error) {
        window.console.error(error);

        this.$notify({
          group: 'notifications',
          title: 'Error al exportar',
          text: 'No se pudo exportar las solicitudes de pagos consolidadas',
          type: 'error',
        });
      } finally {
        this.descargandoExcelSolicitudesPagosConsolidado = false;
      }
    },
    async obtenerPdfSolicitudesPagosConsolidado(mes) {
      if (!mes) {
        return;
      }

      this.descargandoPdfSolicitudesPagosConsolidado = true;

      try {
        const params = {
          mes,
        };
        const response = await programaUniversidadPdfService.inscritosSolicitudesPagosConsolidadosRaw({ params });
        const data = response.data;
        const blob = new Blob([data], {
          type: 'application/pdf',
        });
        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `solicitudes_pagos_consolidado_${mes}.pdf`);
        document.body.appendChild(link);
        link.click();

        this.$notify({
          group: 'notifications',
          title: 'Exportación exitosa',
          text: 'Solicitudes de pagos consolidadas exportadas correctamente',
          type: 'success',
        });
      } catch (error) {
        this.$notify({
          group: 'notifications',
          title: 'Error al exportar',
          text: 'No se pudo exportar las solicitudes de pagos consolidadas',
          type: 'error',
        });
      } finally {
        this.descargandoPdfSolicitudesPagosConsolidado = false;
      }
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>